export default "__VITE_ASSET__CDpdbwym__"